module.exports = __webpack_public_path__ + "static/media/Notifications.4b8c6013.svg";